import React from "react";

import Currency from "./Currency";
import { TotalTrackerContainer, SelectionEdit } from "../styles";
import BoxSizeSelector from "./common/BoxSizeSelector";

const SelectionTotalTracker = ({
  selection,
  limit,
  sizes,
  setShowMessages,
  isMobile,
  showMessages,
  handleLimitChange,
}) => {
  const getCurrentQuantity = () => {
    let total = 0;
    selection.forEach((selectionItem) => {
      selectionItem !== null ? total++ : null;
    });
    return total;
  };

  const getPrice = () => {
    let p = 0;
    selection.forEach((selectionItem) => {
      selectionItem !== null ? (p += parseInt(selectionItem.price)) : null;
    });
    return <Currency value={p} />;
  };

  return (
    <>
      <TotalTrackerContainer className={`${isMobile ? '' : 'mt-3 mb-2'}`} $isMobile>
        {showMessages ? (
          <div className="col-4 px-0">
            <SelectionEdit
              className="text-left m-0"
              onClick={() => setShowMessages(false)}
            >
              Selection
            </SelectionEdit>
          </div>
        ) : (
          <div
            className={`${
              selection.filter((item) => item !== null).length === limit
                ? "box-full"
                : ""
            } col-4 px-0 selection-total`}
          >
            total <span>{getCurrentQuantity()}</span>
            <span>/{limit}</span>
          </div>
        )}
        {isMobile && (
          <BoxSizeSelector
            limit={limit}
            sizes={sizes}
            handleLimitChange={handleLimitChange}
            nolabel={true}
          />
        )}
        <div className="col-4 px-0 text-right selection-price">
          {getPrice()}
        </div>
      </TotalTrackerContainer>
    </>
  );
};

export default SelectionTotalTracker;
